import ContactForm from "./ContactForm";
import OurLocation from "./OurLocation";

const GetInTouch = () => {
  return (
    <section className="apply-for-loan contact">
      <div className="overlay pt-120 pb-120">
        <div className="container wow fadeInUp">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-header text-center">
                <h4 className="title">Get in touch with us.</h4>
                <p>
                  Tinggalkan pesan dan kami akan membalas dalam 1x24 jam. Atau langsung chat/call ke +62-821-7820-8800
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="form-content">
                {/* Contact Form here <ContactForm /> */}

                <OurLocation />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
